// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import store from "./store/index";
Vue.use(Vuex);

// 引入element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 引入vant
import Vant from "vant";
import "vant/lib/index.css";

// 引入"jquery";
import jquery from "jquery";
/**
 *描述：全局注册jQuery
 *版本：1.0
 */
Vue.prototype.jquery = jquery;

// import { getCookie, setCookie, getURLQueryString } from "@/utils/common";
import "@/utils/addQuery"; // 设置全局用 query

// 引入预览图片组件 指令：v-viewer czc
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
Vue.use(Viewer);
// 引入图片加载预处理方法 指令： v-real-img czc
import "@/utils/directive.js";

// 引入微信sdk
import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

// 引入接口
import requestGlobal from "@/api";
Vue.prototype.$request = requestGlobal;

// 引入一键复制
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// 引入上拉加载下拉刷新组件
import BScroll from "better-scroll";
Vue.prototype.$BScroll = BScroll;
import xyjRefresh from "@/components/xyjRefresh.vue";
Vue.component("scroller", xyjRefresh);

// 引入md5加密
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

// 引入音视频播放组件
import VideoPlayer from "vue-video-player/src";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
Vue.use(VideoPlayer);

// 引入省市区组件
import province from "../static/cityData.js";
Vue.prototype.province = province;

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Vant);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js